import { Badge } from "@/components/ui/badge";

const TYPE_LABELS = {
  missing_deduction: "Missing deduction",
  duplicate_deduction: "Duplicate deduction",
  stale_deduction: "Deducted but cancelled",
  flag_mismatch: "Flag out of sync",
  ledger_mismatch: "Balance ≠ ledger",
  past_untagged: "Past class untagged",
  double_booked: "Double-booked time",
  unlinked_booking: "Not linked to account",
  teacher_not_linked: "Not linked to tutor",
  possible_duplicate: "Possible duplicate class",
  unpayable_class: "Unpaid: rate not matched",
  counted_for_other_teacher: "Counted for other teacher",
  foreign_class_counted: "Other tutor's class counted",
  cancelled_still_counted: "Cancelled but paid",
  overdrawn: "Overdrawn",
  absent_deducted: "Absent wrongly deducted",
};

const SEVERITY = {
  high: "bg-rose-50 text-rose-700 border-rose-200",
  medium: "bg-amber-50 text-amber-700 border-amber-200",
  low: "bg-slate-50 text-slate-600 border-slate-200",
};

export const issueLabel = (t) => TYPE_LABELS[t] || t;

export function IssueBadge({ issue }) {
  return (
    <Badge variant="outline" className={SEVERITY[issue.severity] || SEVERITY.low}>
      {issueLabel(issue.type)}
    </Badge>
  );
}

export function IssueList({ issues, testid }) {
  if (!issues?.length) return <p className="text-sm text-slate-500">No issues.</p>;
  return (
    <ul className="divide-y divide-slate-100 text-sm" data-testid={testid}>
      {issues.map((i, idx) => (
        <li key={idx} className="py-2 flex flex-wrap items-start gap-2">
          <IssueBadge issue={i} />
          <span className="text-slate-700 flex-1 min-w-[240px]">{i.message}</span>
          {(i.date || i.tutor_name) && (
            <span className="text-xs text-slate-400 whitespace-nowrap">
              {[i.date, i.time, i.tutor_name].filter(Boolean).join(" · ")}
            </span>
          )}
          {i.credit_effect ? (
            <span className={`text-xs font-semibold ${i.credit_effect > 0 ? "text-emerald-700" : "text-rose-700"}`}>
              {i.credit_effect > 0 ? `+${i.credit_effect}` : i.credit_effect} credit
            </span>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
